import request from '@/utils/request'
const apiPath = '/course/courseSubjectBarrierDutyTeacher'
import { downloadBlob } from '@/utils/download'
const courseSubjectBarrierDutyTeacherApi = {
  /**
   * 新增【值班老师】
   */
  create(data) {
    return request.post(apiPath + '/save2', data)
  },
  /**
   * 修改【值班老师】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【值班老师】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【值班老师】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【值班老师】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
}
export default courseSubjectBarrierDutyTeacherApi
